/**
 *
 * @module component/partials
 * @author Greg Babula [greg.babula@mlb.com]
 *
 */

/**
 *
 * @name partials
 * @desc handlebars partials to be registered
 * @note paths must be hardcoded because Browserify can only do static string analysis
 * @note assign members to partials by directly importing .html files with handlebars syntax.
 *
 */
const partials = {

};

export default partials;
